import type { TranslateFn } from '@mangovoice/mango-ui'

import { type SoundClipTranslateFn, text } from '../types/i18n.types'

// Keep in sync with the "max 25 MB" copy shown on the upload dropzones. Oversized
// clips get their TLS connection dropped at the music-service edge rather than a
// clean rejection, so stop them here before upload.
export const MAX_AUDIO_FILE_BYTES = 25 * 1024 * 1024

const VALID_AUDIO_TYPES = [
  'audio/wav',
  'audio/x-wav',
  'audio/mpeg',
  'audio/mp3',
]

const hasValidType = (file: File): boolean =>
  VALID_AUDIO_TYPES.includes(file.type) || /\.(wav|mp3)$/i.test(file.name)

/**
 * Validate a selected audio file's type and size. Returns a user-facing error
 * message when invalid, or null when the file is acceptable.
 */
export const validateAudioFile = (
  file: File,
  t?: TranslateFn | SoundClipTranslateFn,
): string | null => {
  if (!hasValidType(file)) {
    return text(
      t,
      'soundClips.upload.invalidType',
      'Unsupported file type. Please upload a WAV or MP3.',
    )
  }
  if (file.size > MAX_AUDIO_FILE_BYTES) {
    return text(
      t,
      'soundClips.upload.tooLarge',
      'File is too large. The maximum size is 25 MB.',
    )
  }
  return null
}
